/**
 * Checks if a user role has admin access
 * @param {string} userRole - The user's role
 * @returns {boolean} - True if the user has admin or super_admin role
 */
export const hasAdminAccess = (userRole) => {
  if (!userRole) {
    return false;
  }
  const normalizedRole = userRole.trim();
  return normalizedRole === 'admin' || normalizedRole === 'super_admin';
};

